const initializeLazyLoading = (list, loadMoreBtn) => {

    loadMoreBtn.addEventListener("click", function(event) {

        event.preventDefault();
        loadMoreBtn.classList.add("isLoading");
        loadMoreBtn.disabled = true;

        fetch(this.dataset.link)
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {

                html = new DOMParser().parseFromString(html, 'text/html');
                let newArticles = html.querySelectorAll('.articleList > ul > .articleListItem__article');
                let newBtn = html.querySelector('.articleList__loadMore > a');

                newArticles.forEach(function(article){
                    list.appendChild(article);
                });

                // Override ajax urls if needed, remove btn if there is no next page
                if(newBtn){
                    loadMoreBtn.dataset.link = newBtn.dataset.link;
                    loadMoreBtn.href = newBtn.href;
                    loadMoreBtn.classList.remove("isLoading");
                    loadMoreBtn.blur();
                    loadMoreBtn.disabled = false;
                } else {
                    loadMoreBtn.parentNode.removeChild(loadMoreBtn);
                }
            })
            .catch(function (err) {
                loadMoreBtn.classList.remove("isLoading");
                loadMoreBtn.disabled = false;
                console.warn('Something went wrong.', err);
            });
    });
};

const initializeArticleList = () => {

    const list = document.querySelector(`.articleList > ul`);
    const loadMoreBtn = document.querySelector(".articleList__loadMore > a");

    if(list){
        if(loadMoreBtn) initializeLazyLoading(list, loadMoreBtn);
    }
};

initializeArticleList();